module.exports = __webpack_public_path__ + "img/logo_bpjsk.7bc65f34.png";